import { InputBase, InputController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * Form control for editing/viewing markdown content.
 * @example
 * ```html
 * <salaxy-input-markdown name="md" ng-model="row.md" label="Document"></salaxy-input-markdown>
 * ```
 */
export class InputMarkdown extends ComponentBase {

    /** ng-model is required, form tag is optionally used for validation and disabled/readonly */
    public require = {
      model: "ngModel",

      form: "?^^form",
  };

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = InputBase.crudBindings;

    /** Uses the InputController */
    public controller = InputController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/form-controls/InputMarkdown.html";
}
